import { render, staticRenderFns } from "./buildGeneration.vue?vue&type=template&id=12801cfa&"
import script from "./buildGeneration.vue?vue&type=script&lang=js&"
export * from "./buildGeneration.vue?vue&type=script&lang=js&"
import style0 from "./buildGeneration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports